import { Box, InputAdornment, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material';
import React, { Fragment, useEffect, useState } from 'react'
import ReadOnlyRow from './ReadOnlyRow';
import ConfirmDialog from '../../../components/ConfirmDialog';
import AddEditDispositivo from './AddEditDispositivo';
import SearchIcon from '@mui/icons-material/Search';
import { useDispositivosMutation } from '../../../hooks/mutations';



const TablaDispositivos = ({ currentUser, dispositivos, usuarios, titulo }) => {

    const [openAddEditDispositivo, setOpenAddEditDispositivo] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const [selectedRow, setSelectedRow] = useState(0);

    const dispositivosMutation = useDispositivosMutation();

    //console.log(dispositivos);
    
    //-----------------------------------------------------------------------------------------
    // Codigo y variables para gestionar el dialogo de confirmación
    //-----------------------------------------------------------------------------------------
    const [openDialog, setOpenDialog] = React.useState(false);
    const [deleteRow, setDeleteRow] = useState({ id: 0 });

    const handleResponse = async (opcion, rowId) => {
        //if(opcion == 'borrar') {
        //    handleDelete(deleteRow.id);
        //}
        //setDeleteRow({id:0});
        //console.log(opcion, rowId);
        if(opcion === 'aceptar') {
            await dispositivosMutation.mutateAsync({comando: "CMD_DELETE_DISPOSITIVO", data: {rowId: rowId}});
        }

    }
    //-----------------------------------------------------------------------------------------    


    //-----------------------------------------------------------------------------------------
    // Codigo y variables para gestionar el dialogo de search
    //-----------------------------------------------------------------------------------------
    const [searchState, setSearchState] = useState('');
    const [shownDevices, setShownDevices] = useState();

    useEffect(() => {
        setShownDevices(newDevicesSearch(searchState));
    }, [dispositivos])  // eslint-disable-line react-hooks/exhaustive-deps

    const handleSearch = (event) => {
        const newValue = event.target.value;
        setSearchState(newValue);
        setShownDevices(newDevicesSearch(newValue));
    }

    const newDevicesSearch = (searchString) => {
        const newDevices = dispositivos?.filter((p) =>
            p.devId.toString().includes(searchString) ||
            p.macAdd.toLowerCase().includes(searchString) ||
            p.imei.toLowerCase().includes(searchString)
        );
        setPage(0);
        return newDevices
    }
    //-----------------------------------------------------------------------------------------

    //-----------------------------------------------------------------------------------------
    // Codigo y variables para gestionar el paginado de la tabla
    //-----------------------------------------------------------------------------------------
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(100);

    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - shownDevices?.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    //-----------------------------------------------------------------------------------------    

    return (
        <Fragment>
            <Stack direction='row' pr={3} component={Paper} elevation={5} sx={{ alignItems: 'center', justifyContent: 'space-between', bgcolor: 'white' }}>
                <div></div>
                <Typography variant="h5" component="h5" p={2} align='center'>
                    {titulo}
                </Typography>

                <TextField
                    fullWidth
                    size="small"
                    type="text"
                    label='Buscar'
                    value={searchState}
                    variant="outlined"
                    onChange={handleSearch}
                    style={{ width: '24%' }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                />
            </Stack>




            <Box m='auto' mt={6} style={{ maxWidth: '1600px', backgroundColor: 'white' }}>
                <Box mt={6}>
                    <TableContainer pr={3} component={Paper} elevation={5} style={{ maxHeight: 620, maxWidth: 1600 }}>
                        <Table stickyHeader size='small'>
                            <TableHead>
                                <TableRow>
                                    <TableCell align='left'></TableCell>
                                    <TableCell align='left'>Row Id</TableCell>
                                    <TableCell align='center' typeof='boolean'>Hab</TableCell>
                                    <TableCell align='left'>Device Id</TableCell>
                                    <TableCell align='left'>N Serial</TableCell>
                                    <TableCell align='left'>Descripción</TableCell>
                                    {/*<TableCell align='left'>Versión HW</TableCell>*/}
                                    {/*<TableCell align='left'>Mac Address</TableCell>*/}
                                    {/*<TableCell align='left'>IMEI</TableCell>*/}
                                    <TableCell align='left'>Cel Dispositivo</TableCell>
                                    {/*<TableCell align='left'>Usuario</TableCell>*/}
                                    <TableCell align='left'>Controles</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(rowsPerPage > 0
                                    ? shownDevices?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    : shownDevices
                                )?.map((row, i) => (




                                    <ReadOnlyRow
                                        key={'rorp_' + i}
                                        row={row}
                                        usuario={
                                            usuarios.find((user) => user.id === row.devUserId)
                                        }
                                        currentUser={currentUser}
                                        setOpenDialog={setOpenDialog}
                                        setOpenAddEditDialog={setOpenAddEditDispositivo}
                                        setIsUpdate={setIsUpdate}
                                        setDeleteRow={setDeleteRow}
                                        selectedRow={selectedRow}
                                        setSelectedRow={setSelectedRow}
                                    />

                                ))}
                                {emptyRows > 0 && (
                                    <TableRow style={{ height: 57 * emptyRows }}>
                                        <TableCell colSpan={6} />
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <TablePagination
                        rowsPerPageOptions={[10, 25, 100]}
                        component="div"
                        count={dispositivos.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />

                </Box>

            </Box>

            {
                <ConfirmDialog
                    openDialog={openDialog}
                    setOpenDialog={setOpenDialog}
                    texto='Por favor confirme que desea borrar el dispositivo:'
                    identificador={'Device Id: ' + deleteRow.devId}
                    rowId={deleteRow.id}
                    handleResponse={handleResponse}
                />
            }

            {
                <AddEditDispositivo
                    openDialog={openAddEditDispositivo}
                    setOpenDialog={setOpenAddEditDispositivo}
                    isUpdate={isUpdate}
                    selectedRow={selectedRow}
                    usuario={
                        usuarios.find((user) => user.id === selectedRow.devUserId)
                    }
                />
            }

        </Fragment>
    )
}

export default TablaDispositivos